import React from 'react';
import * as d3 from "d3";
import { getCode, getEdoName } from '../../funcs/vars';
var mex = require('../../static/mexicogeojson.json');

export default class Map extends React.Component{

  componentDidMount(){
    var self = this;
    if(this.svg){
      this.set();
    }
    window.addEventListener('on_fetch', function(){
      self.set();
    })
  }

  set(){
    var self = this;
    var e = this.svg;
    e.innerHTML = "";
    var id = e.getAttribute('id');
    var b = e.getBoundingClientRect();
    var w = b.width;
    var h = b.height;

    var cs = {};

    var data = this.props.data;

    console.log('data', data, this.props.highlight);
    var ad = [];
    var min = 1000;
    var max = 0;

    for(var key in data){
      var v = parseInt(data[key]);
      min = Math.min(v, min);
      max = Math.max(v, max);

      var i = [key, parseInt(data[key])];
      if(key == this.props.highlight){
        var current = i;
      }
      ad.push(i);
    }


    var canvas = d3.select('#' + id)
                   .attr('width', w)
                   .attr('height', h);


    var projection = d3.geoMercator().scale(620).center([-102.5, 23.6])
                                                 .translate([w / 2, h / 2])
    var path = d3.geoPath().projection(projection);

    var g = canvas.append('g');

    var features = mex.features;


    var ll = {};

    g.selectAll('path')
     .data(features)
     .enter()
     .append('path')
     .attr('d', path)
     .attr('vector-effect', 'non-scaling-stroke')
     .attr('fill', function(d){
       var code = getCode(d.properties['name']);
       ll[code] = [d.properties.latitude, d.properties.longitude];
       if(self.props.highlight == code){
         return "rgba(153, 41, 72, 0.69)";
       }
       return 'rgba(90,90,90, 0.49)'

     })

     console.log('ll', ll, max, min, ad);

     /* Círculos */
     var cg = canvas.append('g')
                    .attr('class', 'circles')
     var max_w = 18;
     var min_w = 2;
     cg.selectAll('g')
        .data(ad)
        .enter()
        .append('g')
        .append('circle')
        .attr('r', function(d){
          var v = d[1];
          var pct = ((v - min) / (max - min));
          d.pct = pct;
          var r = (pct * (max_w - min_w)) + min_w;
          d.code = d[0];
          return r;
        })
        .attr('cx', function(d){
          var coords = ll[d[0]].reverse();
              coords = projection(coords);
          d.coords = coords;
          return coords[0]
        })
        .attr('cy', function(d){
          return d.coords[1];
        })
        .attr('fill', function(d){
          return 'rgba(240, 1, 67,'+(d.pct * 0.9)+')';

        })


  }

  render(){
    return(
      <div className="icc_map">
        <svg
          ref={(ref) => this.svg = ref}
          id={"icc_map_" + Math.round(Math.random() * 9999)}>
        </svg>

      </div>
    )
  }
}
